import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { ReactNode } from 'react';

interface DropdownMenuBaseProps {
  trigger: ReactNode;
  children: ReactNode;
  align?: 'start' | 'center' | 'end';
}

export function DropdownMenuBase({ trigger, children, align = 'start' }: DropdownMenuBaseProps) {
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger className="cursor-pointer" asChild>
        {trigger}
      </DropdownMenuTrigger>

      <DropdownMenuContent className="w-fit rounded-md" align={align}>
        {children}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
